import {severityType} from "../components/Widgets/SnackBar";
import {NotificationValue, NotificationConfig} from "../actions/types";


const INITAL_STATE: NotificationValue = {
  show: false,
  messageType: severityType.success,
  notification: [],
}

export default (state = INITAL_STATE, action: { type: string, payload: NotificationConfig }) => {
  switch (action.type) {
    case "CONFIG_MESSAGE":
      return { ...state, ...action.payload  };
    case "PUSH_MESSAGE":
      const newMessage = [...state.notification, action.payload.message];
      return { ...state, ...action.payload, notification: newMessage };
    case "CLEAR_MESSAGE":
      return { ...state, notification: [] };
    case "CLOSE_MESSAGE":
      return { ...state, show: false, notification: [] };
    default:
      return state;
  }
}
